import { useMediaQuery } from "@material-ui/core"
import moment from "moment"
import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { AanvullendeDataFragment } from "../../__generated__/graphql-gatsby"
import CollapseBox from "../collapseBox"
import DataTable from "./dataTable"

interface IProps {
  dates: Maybe<Array<Maybe<AanvullendeDataFragment>>>
}

const Wrapper = styled.div`
  padding-top: ${({ theme }) => theme.spacing(2)}px;
  padding-bottom: ${({ theme }) => theme.spacing(2)}px;
  max-width: 400px;
  margin: 0 auto;
`

const CollapseDates: React.FC<IProps> = ({ dates }) => {
  const [prefix, setPrefix] = useState("")
  const showPrefix = useMediaQuery("(min-width:720px)")

  useEffect(() => {
    if (showPrefix) {
      setPrefix("van ")
    } else {
      setPrefix("")
    }
  }, [showPrefix])

  return (
    <CollapseBox title="Overige data" color="secondary">
      <Wrapper>
        <DataTable
          padding="normal"
          addBorder
          rows={
            dates?.map(date => ({
              label: `${moment(new Date(date?.datum || 0)).format(
                "D MMMM YYYY"
              )}`,
              data: `${prefix}${date?.startTijd} t/m ${date?.eindTijd}`,
            })) || []
          }
        />
      </Wrapper>
    </CollapseBox>
  )
}

export default CollapseDates
